import React, { Fragment } from "react";
import useGet from "../../hooks/useGet";
import Result from "./Result";
import Loading from "../Loading";

const NoFund = () => {
  return (
    <li className="QuickSearch-results-item QuickSearch-results-noFund f-scale-body">
      <a className="c-gray-dark" href="/disease-fund-availability">
        I do not see a fund for my disease
      </a>
    </li>
  );
};

const Results = (props) => {
  const [loading, response, error] = useGet(props.url, {
    params: props.params,
  });

  return (
    <div className="QuickSearch-results" role="alert" aria-live="polite">
      {loading && <Loading className="Loading--small" label="Searching..." />}

      {response && response.data && response.data.funds && response.data.funds.length !== 0 && (
        <Fragment>
          <p className="f-label c-purple">Select a Fund</p>
          <ol>
            {response.data.funds.map((result, i) => (
              <Result key={i} result={result} />
            ))}
            <NoFund />
          </ol>
        </Fragment>
      )}

      {response && response.data && response.data.funds && response.data.funds.length === 0 && (
        <ol>
          <li className="QuickSearch-results-item f-scale-body">
            Sorry, there are no medications or diseases associated with your
            search. We still may be able to help.{" "}
            <a href="/contact">Contact us</a>.
          </li>
        </ol>
      )}

      {error && (
        <ol>
          <li className="QuickSearch-results-item f-scale-body">
            {error.message}
          </li>
          <NoFund />
        </ol>
      )}
    </div>
  );
};

export default Results;
